<strong>
  <ng-container *ngIf="jackpot > 1; then showJackpot else showPending"></ng-container>

  <ng-template #showJackpot>
    <small class="inline-block">
      <ng-container *ngIf="currency == 'MXN'">
        mxn
      </ng-container>
      <ng-container *ngIf="currency == 'USD'">
        us
      </ng-container>
      <ng-container *ngIf="currency == 'BRL'">
        r
      </ng-container>
      <ng-container *ngIf="currency == 'AUD'">
        $
      </ng-container>
      <ng-container *ngIf="currency == 'PLN'">
        z
      </ng-container>
    </small>
    <span class="inline-block margin-right-5">
      <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL' || currency == 'MXN'">$</ng-container>
      <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
      <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
      <ng-container *ngIf="currency == 'AUD'">A</ng-container>
      <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
    </span>
    {{jackpot}}
    <small class="jackpot-millions inline-block margin-left-5 uppercase">
      <ng-container *ngIf="('lang' | translate) == 'en'">Million</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'es'">Millones</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'pt'">MILHÕES</ng-container>
    </small>
  </ng-template>

  <ng-template #showPending>
    <small class="inline-block">
      <ng-container *ngIf="('lang' | translate) == 'en'">Pending</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'es'">Pendiente</ng-container>
      <ng-container *ngIf="('lang' | translate) == 'pt'">Pendente</ng-container>
    </small>
  </ng-template>
</strong>
